// extracted by mini-css-extract-plugin
module.exports = {"profile":"UserProfile_profile__gQOnH"};